module.exports = __webpack_public_path__ + "img/thank_2021_tip1_small.185bae22.png";